import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import { param } from 'jquery';
const EventApi = {
    //#region 後臺接口
    //獲取活動列表
    GetEventList(params) {
        return axios.post(`${base.dev}/services/app/AdminActivity/GetAll`, params)
    },
    //根據id獲取活動
    GetEvent(params) {
        return axios.get(`${base.dev}/services/app/AdminActivity/GetByContent`, { params })
    },
    //添加活動
    AddEvent(params) {
        return axios.post(`${base.dev}/services/app/AdminActivity/Create`, params)
    },
    //更新活動
    UpdateEvent(params) {
        return axios.put(`${base.dev}/services/app/AdminActivity/Update`, params)
    },
    //刪除活動
    DelEvent(params) {
        return axios.delete(`${base.dev}/services/app/AdminActivity/Delete`, { params: params })
    },
    //加入推荐
    UpdateRecommend(params) {
        return axios.get(`${base.dev}/services/app/AdminActivity/UpdateRecommend`, { params })
    },
    //獲取自身添加的收藏
    getFavoriteByUserId(params) {
        return axios.get(`${base.dev}/services/app/Activity/getFavoriteByUserId`, { params })
    },

    //獲取活動類型
    GetEventType(params) {
        return axios.get(`${base.dev}/services/app/AdminCommonType/GetAll`, { params })
    },
    //根據id獲取活動類型
    getEventTypeByid(params) {
        return axios.get(`${base.dev}/services/app/AdminCommonType/Get`, { params })
    },
    //新增活動類型
    AddEventType(params) {
        return axios.post(`${base.dev}/services/app/AdminCommonType/Create`, params)
    },
    //排序
    SortEventType(params) {
        return axios.post(`${base.dev}/services/app/AdminCommonType/UpdateStore`, params)
    },
    //修改活動類型
    EditEventType(params) {
        return axios.put(`${base.dev}/services/app/AdminCommonType/Update`, params)
    },
    //刪除活動類型
    DelEventType(params) {
        return axios.delete(`${base.dev}/services/app/AdminCommonType/Delete`, { params: params })
    },

    //#endregion
    //#region 前台接口
   //獲取活動列表
      GetEventListDesk(params) {
        return axios.post(`${base.dev}/services/app/Activity/GetAll`, params)
    },
    getEventListBydate(params){
        return axios.post(`${base.dev}/services/app/Activity/GetAllByPhoto`, params)
    },
    getIndexActivieyList(params){
        return axios.post(`${base.dev}/services/app/Activity/GetIndexActivieyList`, params)
    },
     //根據id獲取活動
     GetEventDesk(params) {
        return axios.get(`${base.dev}/services/app/Activity/GetByContent`, { params })
    },
    GetNearAllListDesk(params) {
        return axios.post(`${base.dev}/services/app/Activity/GetNearAll`, params)
    },
    GetEventTypeDesk(params) {
        return axios.get(`${base.dev}/services/app/CommonType/GetAll`, { params })
    },
    //根據id獲取活動類型
    getEventTypeByidDesk(params) {
        return axios.get(`${base.dev}/services/app/CommonType/Get`, { params })
    },
    sendEmail(params){
        return axios.post(`${base.dev}/services/app/Activity/SendActivityData`,params )
    },
    sendOpinion(params){
        return axios.post(`${base.dev}/services/app/Activity/SendOpinion`,params )
    },
    //浏览量增加
    pageViews(params) {
        return axios.post(`${base.dev}/services/app/Activity/UpdateStatistics`, params)
    },
    //#endregion
}
export default EventApi


// WEBPACK FOOTER //
// ./src/api/Event/EventApi.js